export default {
    firmware_tab_version: "Versión del firmware",
    firmware_tab_hardware_version: "Versión de hardware",
    firmware_tab_status: "Estado",
    firmware_tab_default: "Por defecto",
    firmware_tab_firmware_type: "Tipo de firmware",
    firmware_tab_description: "Descripción",
    firmware_tab_release_time: "Hora de la liberación",
    firmware_tab_label: "Actualizar las versiones de firmware",
    firmware_tab_active: "Activo",
    firmware_tab_deactivated: "Desactivado",
    firmware_tab_yes: "Si",
    firmware_tab_no: "No",
    firmware_tab_assign_firmware_to: "Asignar firmware a",
    firmware_tab_update_vidfleet_devices: "Actualizar Dispositivos VidFleet"
}